import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useCallback } from 'react';
import { thunkSetCreateGameVariantId } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { HEADER_SUBTITLE_COLOR } from '../../../styles/colors';
import { ALL_POKER_VARIANT_PROPERTIES, ALL_POKER_VARIANTS } from '../../../types/pokerVariantTypes';
import { MixedGameLabel } from '../../mixedGameLabel';
export const PokerVariantControl = () => {
    const dispatch = useAppDispatch();
    const variantId = useAppSelector((state) => state.createGame.variantId);
    const onChangeVariant = useCallback((event) => {
        dispatch(thunkSetCreateGameVariantId(Number(event.target.value)));
    }, [dispatch]);
    return (_jsxs(FormControl, { variant: 'outlined', children: [_jsx(InputLabel, { children: "Poker Variant" }), _jsxs(Select, { "data-testid": 'create-game-variant-select', value: `${variantId}`, label: 'Poker Variant', onChange: onChangeVariant, children: [ALL_POKER_VARIANTS.map((variant, i) => (_jsx(MenuItem, { value: ALL_POKER_VARIANT_PROPERTIES[variant].variantId, children: ALL_POKER_VARIANT_PROPERTIES[variant].name }, i))), _jsx(MenuItem, { value: ALL_POKER_VARIANTS.length, children: _jsx(MixedGameLabel, { label: 'Mixed Game', marginRight: 5, color: HEADER_SUBTITLE_COLOR }) })] })] }));
};
